import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@/components/ui/skeleton';

export function AssistantConversationSkeleton() {
  const { t } = useTranslation();
  return (
    <div className="space-y-3" data-testid="assistant-conversation-loading" aria-busy="true">
      <p role="status" className="flex items-center gap-2 text-xs text-muted-foreground">
        <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />
        {t('aiAssistant.openingConversation')}
      </p>
      <Skeleton className="ml-auto h-9 w-2/3 rounded-2xl" />
      <Skeleton className="h-16 w-5/6 rounded-2xl" />
      <Skeleton className="ml-auto h-9 w-1/2 rounded-2xl" />
      <Skeleton className="h-24 w-4/5 rounded-2xl" />
    </div>
  );
}
